import { render } from "./PhonebotVersions.vue?vue&type=template&id=a41bd1cc&scoped=true"
import script from "./PhonebotVersions.vue?vue&type=script&lang=js"
export * from "./PhonebotVersions.vue?vue&type=script&lang=js"

import "./PhonebotVersions.vue?vue&type=style&index=0&id=a41bd1cc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\fchristo\\Documents\\adam-aibackend\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a41bd1cc"]])

export default __exports__